import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Parser from "ua-parser-js";

import "./App.css";
import "./css/common.css";

import Home from "./containers/Home";
import ShopView from "./containers/ShopView";
import ShopAdmin from "./containers/ShopAdmin";
import AdminPanel from "./containers/AdminPanel";
import ShopRequest from "./containers/ShopRequest";
import Checkout from "./containers/Checkout";
import UserProfile from "./containers/UserControl/UserProfile";
import About from "./components/Rules/About";
import CustomerTerms from "./components/Rules/CustomerTerms";
import DataSecuirity from "./components/Rules/DataSecuirity";
import FAQ from "./components/Rules/FAQ";
import ShopTerms from "./components/Rules/ShopTerms";
//dasdasd
function App() {
  // var parser = new Parser();
  // console.log(parser.getResult());
  return (
    <Router>
      <div className="App">
        <Route path="/" exact component={Home} />
        <Route path="/shop/:shopId" component={ShopView} />
        <Route path="/merchant" component={ShopAdmin} />
        <Route path="/admin" component={AdminPanel} />
        <Route path="/shop-request" exact component={ShopRequest} />
        <Route path="/checkout" exact component={Checkout} />
        <Route path="/user-profile" component={UserProfile} />
        <Route path="/about" exact component={About} />
        <Route path="/faq" exact component={FAQ} />
        <Route path="/privacy" exact component={DataSecuirity} />
        <Route path="/customer-terms" exact component={CustomerTerms} />
        <Route path="/shop-terms" exact component={ShopTerms} />
      </div>
    </Router>
  );
}

export default App;
